<template>
  <div class="container pathways__subcomponent">
    <div class="columns is-centered is-not-vertical">
      <div class="column is-10-tablet is-8-desktop">
        <p class="title is-3 pathways-question__indicator">Question 5</p>
        <h2 class="title is-1">
          In the past three months, how often have you had an all-consuming, overwhelming urge to
          use the following?
        </h2>
      </div>
    </div>
    <div class="columns is-centered is-multiline">
      <div v-for="drug in drugSelections" :key="drug.data.label" class="column is-8-tablet">
        <PathwaysDrugCard v-bind="drug.data" class="mb-16-24" />
        <div class="pathways__option-tight-container">
          <PathwaysOption label-text="Never">
            <input
              type="radio"
              :name="`${drug.data.label}-never`"
              value="never"
              v-model="desire[drug.data.label]"
              @change="updateNext()"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Once or twice">
            <input
              type="radio"
              :name="`${drug.data.label}-once-twice`"
              value="once-twice"
              v-model="desire[drug.data.label]"
              @change="updateNext()"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Monthly">
            <input
              type="radio"
              :name="`${drug.data.label}-monthly`"
              value="monthly"
              v-model="desire[drug.data.label]"
              @change="updateNext()"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Weekly">
            <input
              type="radio"
              :name="`${drug.data.label}-weekly`"
              value="weekly"
              v-model="desire[drug.data.label]"
              @change="updateNext()"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Daily or almost daily">
            <input
              type="radio"
              :name="`${drug.data.label}-daily`"
              value="daily"
              v-model="desire[drug.data.label]"
              @change="updateNext()"
            />
          </PathwaysOption>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PathwaysDrugCard from '@/components/pathways/PathwaysDrugCard.vue';
import PathwaysOption from '@/components/pathways/PathwaysOption.vue';

const { mapActions, mapGetters } = createNamespacedHelpers('pathways');

export default {
  name: 'PathwaysQuestionSelfDesire',
  components: { PathwaysDrugCard, PathwaysOption },
  data() {
    return {
      desire: {},
    };
  },
  computed: {
    ...mapGetters(['drugSelections']),
  },
  mounted() {
    this.desire = this.$store.state.pathways.responses.desire || {};
    this.updateNext();
  },
  beforeUnmount() {
    this.updateResponses({ desire: this.desire });
  },
  methods: {
    /**
     * Enable next if all selections nade and vice versa
     */
    updateNext() {
      const allChecked = this.drugSelections.every((drug) => this.desire[drug.data.label]);
      this.setNextDisabled(!allChecked);
    },
    ...mapActions({
      setNextDisabled: 'disableNext',
      updateResponses: 'updateResponses',
    }),
  },
};
</script>
